import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import EditingHelpText, { MissingDataSource } from 'components/helpers/EditingHelpText';
import VideoItem, { VideoItemProps } from 'components/helpers/VideoItem/VideoItem';

export type VideoProps = Sitecore.Override.ComponentBase &
  Components.General.Video.Fields.Video & {
    fields: {
      selectVideo: VideoItemProps;
    };
  };
const Video = ({ fields }: VideoProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }

  return (
    <div data-component="authorable/general/video">
      <div>
        {!fields.selectVideo ? (
          <EditingHelpText text="Video Component | No Video Selected. " />
        ) : (
          ''
        )}
        <VideoItem {...fields.selectVideo} videoSide={fields.videoSide} />
      </div>
    </div>
  );
};
export default Video;
